'use client';
import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Cell,
} from 'recharts';

// BACKEND INTEGRATION: GET /api/admin/occupancy?month=2026-05
const occupancyData = [
  { name: 'Sunset\nTerrace', shortName: 'Suite', pct: 82, color: 'var(--primary)' },
  { name: 'Ocean\nBreeze', shortName: 'Loft', pct: 74, color: 'var(--secondary)' },
  { name: 'Garden\nVilla', shortName: 'Villa', pct: 91, color: '#10b981' },
  { name: 'Rooftop\nHaven', shortName: 'Roof', pct: 65, color: 'var(--accent)' },
];

const CustomTooltip = ({ active, payload }: { active?: boolean; payload?: Array<{ payload: { name: string; pct: number } }> }) => {
  if (active && payload && payload.length) {
    const d = payload[0].payload;
    return (
      <div className="bg-card border border-border rounded-xl shadow-card p-3">
        <p className="text-xs font-700 text-foreground">{d.name.replace('\n', ' ')}</p>
        <p className="text-xs text-muted-foreground">Occupancy: <span className="font-700 text-foreground">{d.pct}%</span></p>
      </div>
    );
  }
  return null;
};

export default function OccupancyChart() {
  return (
    <div className="card-base p-5 h-full">
      <div className="mb-5">
        <h3 className="font-700 text-base text-foreground">Occupancy by Apartment</h3>
        <p className="text-xs text-muted-foreground mt-0.5">May 2026 · % nights booked</p>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={occupancyData} margin={{ top: 5, right: 5, left: -20, bottom: 5 }} barSize={32}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" horizontal vertical={false} />
          <XAxis
            dataKey="shortName"
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            domain={[0, 100]}
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${v}%`}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--muted)', opacity: 0.5 }} />
          <Bar dataKey="pct" radius={[6, 6, 0, 0]}>
            {occupancyData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 space-y-2">
        {occupancyData.map((apt) => (
          <div key={`occ-row-${apt.shortName}`} className="flex items-center gap-3">
            <div className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: apt.color }} />
            <span className="text-xs text-muted-foreground flex-1 truncate">{apt.name.replace('\n', ' ')}</span>
            <div className="flex items-center gap-2">
              <div className="w-20 h-1.5 bg-muted rounded-full overflow-hidden">
                <div className="h-full rounded-full" style={{ width: `${apt.pct}%`, backgroundColor: apt.color }} />
              </div>
              <span className="text-xs font-700 text-foreground tabular-nums w-8 text-right">{apt.pct}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}